import { Page } from '@app/components/page/Page';
import { PageBreadcrumbsProps } from '@app/components/page/header/breadcrumbs/PageBreadcrumbs';
import { compact } from 'lodash';
import { useIntl } from 'react-intl';
import { AuditIcon } from '../AuditIcon';

export interface AuditBreadcrumbsProps {
  items?: PageBreadcrumbsProps['items'];
}

export function AuditBreadcrumbs({ items = [] }: AuditBreadcrumbsProps) {
  const { $t } = useIntl();

  return (
    <Page.Breadcrumbs
      items={compact([
        {
          icon: <AuditIcon sx={{ fontSize: '14px' }} />,
          content: $t({
            id: 'audit.title',
            defaultMessage: 'Auditoría',
          }),
        },
        ...(items ?? []),
      ])}
    />
  );
}
